import { render, staticRenderFns } from "./TargetCityItem.vue?vue&type=template&id=477adfaf&scoped=true&"
import script from "./TargetCityItem.vue?vue&type=script&lang=js&"
export * from "./TargetCityItem.vue?vue&type=script&lang=js&"
import style0 from "./TargetCityItem.vue?vue&type=style&index=0&id=477adfaf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477adfaf",
  null
  
)

export default component.exports